
/* styles */
require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-1fe7cb28\",\"scoped\":false,\"hasInlineConfig\":false}!sass-loader?{\"data\":\"@import \\\"~scss/variables\\\";\",\"sourceMap\":true}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./RevisionHistory.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./RevisionHistory.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-1fe7cb28\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./RevisionHistory.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/appComponents/revisionHistory/RevisionHistory.vue
// module id = 1663
// module chunks = 0